<template>
  <div v-show="showBar" @keyup.esc="closeStickyBar" class="vch-sticky-bar">
    <div class="container">
      <div class="vch-grid vch-sticky-bar__content">
        <slot name="title" />
        <slot name="description" />
        <div
          :class="[
            'vch-sticky-bar__content vch-sticky-container',
            closeBtn ? 'vch-col-12 vch-col-md-4' : 'vch-col-12',
          ]"
        >
          <slot name="button" />
        </div>
        <div class="vch-sticky-bar__cta vch-col-1" v-if="closeBtn">
          <button
            class="vch-sticky-bar__close"
            :aria-label="ariaLabel"
            @click="closeStickyBar"
          >
            <svg aria-hidden="true" width="40" height="40">
              <use href="/assets/sprite/icons.svg#close-overlay" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { throttle, isVisible, inViewport } from 'Utils/';
import { pushEvent } from 'Utils/datalayer';
export default {
  name: 'vch-sticky-bar',
  props: {
    closeBtn: {
      type: String,
      required: false,
    },
    ariaLabel: {
      type: String,
      required: false,
    },
    mobileOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showBar: false,
      isCloseBtnClicked: false,
      isElementScrolled: false,
      mql: null,
      mobileViewport: true,
      taggingTriggered: false,
      datalayerBanner: false,
    };
  },
  mounted() {
    window.addEventListener(
      'scroll',
      throttle(this.toggleStickyBar, 100),
      false
    );

    if (this.mobileOnly) {
      this.mql = window.matchMedia('(max-width: 64rem)');
      this.toggleViewport(this.mql);
      this.mql.addEventListener('change', this.toggleViewport);
    }
    //this.dataTagging();
    //this.dataTaggingBannerButton();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', throttle(this.toggleStickyBar, 100));
    if (this.mql) {
      this.mql.removeEventListener('change', this.toggleViewport);
    }
  },
  methods: {
    closeStickyBar() {
      this.showBar = false;
      this.isCloseBtnClicked = true;
    },
    onScrollAfterEl(el) {
      const top = el.getBoundingClientRect().top;
      const bottom = el.getBoundingClientRect().bottom;
      if (top < window.innerHeight && bottom <= 0) {
        this.isElementScrolled = true;
      } else {
        this.isElementScrolled = false;
      }
    },
    onScrollToEl(el) {
      const top = el.getBoundingClientRect().top;
      const height = el.getBoundingClientRect().height;
      const bottom = el.getBoundingClientRect().bottom;
      if (
        (inViewport(el) && top <= height) ||
        this.isCloseBtnClicked ||
        bottom <= 0
      ) {
        this.showBar = false;
      } else {
        this.hideBuyButtonEretailer();
        this.showBar = true;
        if (!this.taggingTriggered) {
          this.dataTagging();
        }
      }
    },
    toggleViewport({ matches }) {
      this.mobileViewport = matches;
      this.toggleStickyBar();
    },
    toggleStickyBar() {
      if (this.mobileOnly && !this.mobileViewport) {
        this.showBar = false;
        return;
      }

      const scrolledElement = document.getElementById('scrolledElement');
      if (scrolledElement) {
        this.closeBtn
          ? this.onScrollToEl(scrolledElement)
          : this.onScrollAfterEl(scrolledElement);
      }
      if (
        !this.isElementScrolled &&
        scrolledElement &&
        isVisible(scrolledElement)
      ) {
        this.showBar = false;
      } else if (scrolledElement && this.isElementScrolled) {
        this.hideBuyButtonEretailer();
        this.showBar = true;
      }
    },
    hideBuyButtonEretailer() {
      const select = (selector) => document.querySelector(selector);
      const retailerInfo = select(
        '.vch-pdp-grid__content .eretailer-unavailable'
      );
      const buyBtn = select('.Product-Page .vch-sticky-bar .buy-btn');
      if (retailerInfo && !retailerInfo.classList.contains('hideInfo')) {
        buyBtn?.classList.add('hideBtn');
      } else {
        buyBtn?.classList.remove('hideBtn');
      }
    },
    dataTagging() {
      let diagButton = document.querySelector(
        '.vch-sticky-bar__content a[data-click-analytics]'
      );
      if (diagButton !== null) {
        let dataAttr = diagButton.getAttribute('data-click-analytics');
        if (dataAttr !== null) {
          this.taggingTriggered = true;
          let formattedDatas = JSON.parse(dataAttr);
          diagButton.addEventListener('click', function () {
            pushEvent({
              event: 'uaevent',
              event_name: formattedDatas.eventProperties.event_name
                ? formattedDatas.eventProperties.event_name
                : 'body_button_click',
              ecommerce: 'undefined',
              eventCategory: formattedDatas.eventProperties.eventCategory
                ? formattedDatas.eventProperties.eventCategory
                : 'undefined',
              eventAction: formattedDatas.eventProperties.eventAction
                ? formattedDatas.eventProperties.eventAction
                : 'undefined',
              eventLabel: formattedDatas.eventProperties.eventLabel
                ? formattedDatas.eventProperties.eventLabel
                : 'undefined',
              module_name: formattedDatas.eventProperties.module_name
                ? formattedDatas.eventProperties.module_name
                : 'undefined',
              link_url: formattedDatas.eventProperties.link_url
                ? formattedDatas.eventProperties.link_url
                : 'undefined',
              cta_name: formattedDatas.eventProperties.cta_name
                ? formattedDatas.eventProperties.cta_name
                : 'undefined',
            });
          });
        }
      }
    },
    dataTaggingBannerButton() {
      if (!this.datalayerBanner) {
        let diagBannerButton = document.querySelector(
          '.SkinDiagnosisInvite a[data-analytics]'
        );
        if (diagBannerButton !== null) {
          let dataBannerAttr = diagBannerButton.getAttribute('data-analytics');
          if (dataBannerAttr !== null) {
            let formattedData = JSON.parse(dataBannerAttr);
            this.datalayerBanner = true;
            diagBannerButton.addEventListener('click', function () {
              pushEvent({
                event: 'uaevent',
                event_name: formattedData.eventProperties.event_name
                  ? formattedData.eventProperties.event_name
                  : 'body_button_click',
                ecommerce: 'undefined',
                eventCategory: formattedData.eventProperties.eventCategory
                  ? formattedData.eventProperties.eventCategory
                  : 'undefined',
                eventAction: formattedData.eventProperties.eventAction
                  ? formattedData.eventProperties.eventAction
                  : 'undefined',
                eventLabel: formattedData.eventProperties.eventLabel
                  ? formattedData.eventProperties.eventLabel
                  : 'undefined',
                module_name: formattedData.eventProperties.module_name
                  ? formattedData.eventProperties.module_name
                  : 'undefined',
                link_url: formattedData.eventProperties.link_url
                  ? formattedData.eventProperties.link_url
                  : 'undefined',
                cta_name: formattedData.eventProperties.cta_name
                  ? formattedData.eventProperties.cta_name
                  : 'undefined',
              });
            });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" src="./sticky-bar.scss"></style>
